module.exports = __webpack_public_path__ + "img/p-void.cdf812ba.png";